module.exports = __webpack_public_path__ + "img/hw-s11.2964dc2b.svg";